import React, { useState, useRef, useEffect } from 'react';
import { submitCisData, getManualSkuList, submitAR, submitEventCisData, submitEventAR } from '../../helper/helper';
import toast from 'react-hot-toast';
import './CisUpload.scss';
import CustomButton from '../../components/ui/Button/Button';
import AccessoryBlock from './AccessoryBlock';
import ManualCisBlock from './ManualCisBlock';
import {
  // extractDiscountInfo,
  hasInitialCredit,
  isPostpaidConnection,
  readFile,
  readSkus,
} from './pdfUtils';
import { DFF_Text, readCIS, readRQ } from './fileTempates';
import { dateConversion } from '../../components/ReusableFunctions';
// import { Button } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';


// const NOT_SELECTED = 'Not Selected';
// const DFF_Text = 'DFF';
// const DFF_RQ_Code = 'ACCANS003120';
// const HUP_RQ_Code = "ACCANS001722"
// const ACT_POSTPAID_RQ_Code ="ACCANS001519"
// const ACT_PREPAID_RQ_Code ="ACCANS001520"
// const CUSTOMER_OWN_PHONE_RQ_Code ="ACCANS001278"

const Home = ({eventinfoforCis}) => {
  const username = localStorage.getItem('username');
  const cisRef = useRef(null);
  const apRef = useRef(null);
  const rqRef = useRef(null);
  const [result, setResult] = useState('');
  const [apresult, setApresult] = useState('');
  const [rqresult, setRqresult] = useState('');
  const [IsSignaturesPresent, setIsSignaturesPresent] = useState(false);

  const [manualSkuList, setManualSkuList] = useState([]);

  useEffect(() => {
    // refactoring this api because we only need to get it once
    const fetchManualSkuList = async () => {
      try {
        const { data } = await getManualSkuList();
        const newData = data?.[0]?.manualFile;
        setManualSkuList(newData);
      } catch (error) {
        toast.error('Sorry, we couldn’t load the data. Please try again later.');
      }
    };

    fetchManualSkuList();
  }, []);

  /* Cis  */
  async function readCisFile(event) {
    const file = event.target.files[0];
    // Validating File type

    if (!file) {
      return;
    }
    const { result, isSignaturesPresent } = await readFile(event);
    // Validate content for CIS file Your Personal Information
    if (!result.startsWith('Your Personal Information') || !result.includes('Account Number')) {
      toast.error('The uploaded file does not appear to be a valid CIS.');
      setResult('');

      return;
    }
    setResult(result);
    setIsSignaturesPresent(isSignaturesPresent);
  }

  async function readApFile(event) {
    const file = event.target.files[0];
    // Validating File type

    if (!file) {
      return;
    }
    const { result } = await readFile(event);
    // QUESTION: DO WE NOT NEED TO CHECK SIGNATURE FOR AP?
    // Validate content for RQ file
    if (
      !result.includes('registered successfully for Pre - Authorized Payments') ||
      !result.includes('Account Number:')
    ) {
      toast.error('The uploaded file does not appear to be a valid AutoPay.');
      setApresult('');

      return;
    }

    setApresult(result);
  }

  async function readRqFile(event) {
    const file = event.target.files[0];
    // Validating File type

    if (!file) {
      return;
    }
    const { result } = await readFile(event);

    // Validate content for RQ file
    if (!result.startsWith('Sale Invoice :') || !result.includes('Thanks for your Business!')) {
      toast.error('The uploaded file does not appear to be a valid RQ invoice.');
      setRqresult('');

      return;
    }
    setRqresult(result);
  }

  async function cisDataExtraction(result) {
    let values = readCIS(result);
    return values;
  }

  async function autoPayDataExtraction(apresult, result) {
    const matches = apresult.match(/successfully for Pre - Authorized Payments/g);
    const customerName = /Customer\sName(.*?)Account\sNumber/i
      .exec(apresult)[1]
      .trim()
      .slice(2)
      .trim();
    const accountNum = /Account\sNumber(.*?)Card\sRegistered/i
      .exec(apresult)[1]
      .trim()
      .slice(2)
      .trim();

    const isPostpaid = isPostpaidConnection(result);
    const hasCreditLimit = hasInitialCredit(result);

    // const isCredit = /Initial(.*?)Limit/i.exec(result)[1]?.trim() === 'Credit';
    const isBringYourOwnPhone =
      /Model(.*?)MyTab/i.exec(result)[1].trim() === 'Bring Your Own Phone';

    // Verify Consitions again
    if (matches) {
      if (isPostpaid && hasCreditLimit && !isBringYourOwnPhone) {
        return { autoPayPost: matches[0], customerName, accountNum, autoPayPre: 'N/A' };
      } else if (isPostpaid && !isBringYourOwnPhone) {
        return { autoPayPost: 'N/A', customerName, accountNum, autoPayPre: 'N/A' };
      } else if (!isPostpaid) {
        return { autoPayPre: matches[0], customerName, accountNum, autoPayPost: 'N/A' };
      } else if (isPostpaid && hasCreditLimit && isBringYourOwnPhone) {
        return { autoPayPost: matches[0], customerName, accountNum, autoPayPre: 'N/A' };
      }
    } else {
      if (isPostpaid && hasCreditLimit && !isBringYourOwnPhone) {
        const autoPayPost = /Pay\sAfter(.*?)Your\scredit\scard/i
          .exec(apresult)[1]
          .trim()
          .slice(-3)
          .trim();
        return { autoPayPost, customerName, accountNum, autoPayPre: 'N/A' };
      } else if (isPostpaid && !isBringYourOwnPhone) {
        return { autoPayPost: 'N/A', customerName, accountNum, autoPayPre: 'N/A' };
      } else if (!isPostpaid) {
        const autoPayPre = /has\sbeen\sregistered(.*?)for\sPre/i.exec(apresult)[1].trim();
        return { autoPayPre, customerName, accountNum, autoPayPost: 'N/A' };
      } else if (isPostpaid && hasCreditLimit && isBringYourOwnPhone) {
        const autoPayPost = /Pay\sAfter(.*?)Your\scredit\scard/i
          .exec(apresult)[1]
          .trim()
          .slice(-3)
          .trim();
        return { autoPayPost, customerName, accountNum, autoPayPre: 'N/A' };
      }
    }
  }

  async function rq4DataExtraction(rqresult) {
    let values = readRQ(rqresult);
    return values;
  }

  function normalizePhone(phone) {
    return phone.replace(/\D/g, ''); // Remove all non-digit characters
  }

  // Function to check if either phoneNum or tempPhoneNum (normalized) is present in the text
  function checkPhoneInText(obj1, obj2, text) {
    const phoneNumNormalized = obj1 && normalizePhone(obj1);
    const tempPhoneNumNormalized = obj2 && normalizePhone(obj2);

    // Check if the normalized phone numbers appear in the text
    const phoneNumInText = phoneNumNormalized && text.includes(phoneNumNormalized);
    const tempPhoneNumInText = tempPhoneNumNormalized && text.includes(tempPhoneNumNormalized);
    const phoneNumInText1 = obj1 && text.includes(obj1);
    const tempPhoneNumInText1 = obj2 && text.includes(obj2);

    return phoneNumInText || tempPhoneNumInText || phoneNumInText1 || tempPhoneNumInText1
      ? true
      : false;
  }

  const onTypeChange = async (e) => {
    e.preventDefault();

    const {
      accessories: attachedAcc,
      discountInfo = {},
      newAccessoriesList,
    } = readSkus(manualSkuList, rqresult);
    let totalCost = 0;
    let totalMsrp = 0;
    let totalDiscount = 0;
    attachedAcc.forEach((item) => {
      const [, , /* productName */ cost, msrp, , , uniqueSkuKey] = item;
      totalCost += cost;
      totalMsrp += msrp;
      if (discountInfo[uniqueSkuKey] && discountInfo[uniqueSkuKey].discount) {
        totalDiscount += discountInfo[uniqueSkuKey].discount;
      }
    });
    let aaData = {
      cost: totalCost,
      msrp: totalMsrp,
      discount: totalDiscount,
    };

    let cisDataValues;
    let autoPayDataValues;
    let rq4DataValues;

    cisDataValues = await cisDataExtraction(result);
    rq4DataValues = await rq4DataExtraction(rqresult, result);
    const formattedDateStr = rq4DataValues.tenderedDate;

    if (document.getElementById('autopay').value !== '') {
      autoPayDataValues = await autoPayDataExtraction(apresult, result);

      if (
        autoPayDataValues.customerName === cisDataValues.customerName &&
        autoPayDataValues.accountNum === cisDataValues.accountNum
      ) {
        cisDataValues = {
          ...cisDataValues,
          autoPayPre: autoPayDataValues.autoPayPre,
          autoPayPost: autoPayDataValues.autoPayPost,
        };
      } else {
        toast.error(
          'wrong customer data.. choose file with same customer name and account number',
        );
        return;
      }
    } else {
      cisDataValues = { ...cisDataValues, autoPayPre: 'N/A', autoPayPost: 'N/A' };
    }
    if (
      rq4DataValues.accountNum === cisDataValues.accountNum ||
      rq4DataValues.imei === cisDataValues.imei ||
      rq4DataValues.accountNum === 'DFF'
    ) {
      cisDataValues = {
        ...cisDataValues,
        storeInvoice: rq4DataValues.storeInvoice,
        saleInvoice: rq4DataValues.saleInvoice,
        tenderedDate: formattedDateStr,
        time: rq4DataValues.time,
      };
    } else {
      toast.error(
        'wrong customer data.. choose file with same customer name and account number',
      );
      return;
    }

    cisDataValues = {
      ...cisDataValues,
      user: username,
      activationTenderedMismatch: cisDataValues.activationDate !== formattedDateStr,
    };

    // If it is a DFF, then phoneNum is not present in RQ, and the condition may be incorrectly evaluated as false
    const resultCheck =  rq4DataValues.imei === DFF_Text && cisDataValues.imei === DFF_Text ? true : checkPhoneInText(
      cisDataValues.phoneNum,
      cisDataValues.tempPhoneNum,
      rqresult,
    );

    const isValidData =
      (rq4DataValues.accountNum === cisDataValues.accountNum ||
        rq4DataValues.storeInvoice ||
        autoPayDataValues.customerName === cisDataValues.customerName ||
        rq4DataValues.accountNum === 'DFF') &&
      IsSignaturesPresent &&
      resultCheck;

    if (isValidData) {
      const { user } = cisDataValues;

      if (user) {
        if (eventinfoforCis){
          let eventName= eventinfoforCis?.name || ''
          let eventDate= eventinfoforCis?.date || ''
          submitEventCisData({...cisDataValues , eventName,eventDate})
          .then(() => {
            resetFields();
            submitEventAR({
              specialistId: cisDataValues.specialistId,
              tenderedDate: cisDataValues.tenderedDate,
              saleInvoice: cisDataValues.saleInvoice,
              discountInfo,
              attachedAcc,
              connectionType: cisDataValues.connectionType,
              simNumber: cisDataValues.simNumber,
              user,
              aaData,
              storeInvoice: cisDataValues.storeInvoice,
              phoneProtectionPlan: cisDataValues.phoneProtectionPlan,
              imei: cisDataValues.imei,
              eventName,
                  eventDate,
              newAccessoriesList,
            });
          })
          .catch(resetFields);
        }
        else{

        submitCisData(cisDataValues)
          .then(() => {
            resetFields();
            submitAR({
              specialistId: cisDataValues.specialistId,
              tenderedDate: cisDataValues.tenderedDate,
              saleInvoice: cisDataValues.saleInvoice,
              discountInfo,
              attachedAcc,
              connectionType: cisDataValues.connectionType,
              simNumber: cisDataValues.simNumber,
              user,
              aaData,
              storeInvoice: cisDataValues.storeInvoice,
              phoneProtectionPlan: cisDataValues.phoneProtectionPlan,
              imei: cisDataValues.imei,
              newAccessoriesList,
            });
          })
          .catch(resetFields);
        }

      } else {
        toast.error('Please logout and try again.');
      }
    } else {
      toast.error('Please upload the correct data or missing signature on CIS.');
    }
  };

  function resetFields() {
    cisRef.current.value = null;
    apRef.current.value = null;
    rqRef.current.value = null;
    setRqresult('');
    setResult('');
    setApresult('');
  }
  return (
    <div className="cisupload">
      <div className="cisupload-container">
        <div className="cisupload-block">
          <div className="cis">
            
             <div className="note">          
              <table className="note-table">
                <thead>
                  <tr>
                    <th>Scenario</th>
                    <th>Required Actions</th>
                  </tr>
               </thead>
                <tbody>
                  <tr>
                    <td rowSpan="2">Activation</td>
                     <td> Upload <b>CIS</b>, RQ4 Invoice, and AutoPay Contract.</td>
                     </tr>
                  <tr>
                    <td><strong>No Autopay:</strong> Upload <b>CIS</b> and <b>RQ4</b> Invoice both.</td>  
                  </tr>
                   <tr>
                    <td rowSpan="3">Manual Submission</td>
                    <td>Use this form if the automatic <b>CIS</b> File Upload <b>FAIL</b>.</td>
                 
                      
                  </tr>
                  <tr>
                    <td><strong>Step 1:</strong> Upload <b>RQ4</b> Invoice only.</td>
                  </tr>
                   <tr>
                    <td><strong>Step 2:</strong> Enter the customer details-<b>CIS</b> manually and submit it. </td>
                  </tr>
                   <tr>
                      <td>Accessory Only</td>
                    <td>Upload <b>RQ4</b> Invoice only.</td>
                    </tr>
                 </tbody>
              </table>              
            </div>
            <div className="top">
              {/* for CIS upload */}
              <div className="block">
                <div className="top-block">
                  <h4>CIS</h4>
                </div>
                
{/*  Error:  user  can see the upload button but  
once user upload they cannot see the name of the  files.
Check the  live  version
try: Split button

ButtonGroup can also be used to create a split button.
to combine 2  upload  buttons
https://mui.com/material-ui/react-button-group/
 */}
                <div className="bottom-block">
                  {/*   <label htmlFor="cis" className="custom-file-label" >Choose CIS File</label>
           */}
                  <input
                    onChange={readCisFile}
                    ref={cisRef}
                    accept=".pdf"
                    multiple={false}
                    type="file"
                    id="cis"
                    name="cis"

                  />
                 
                </div>
              </div>

              {/* for RQ4 upload */}
              <div className="block">
                <div className="top-block">
                  <h4 className="">RQ4</h4>
                </div>

                <div className="bottom-block">
                  {/*  <label htmlFor="rq4" className="custom-file-label">Choose RQ4 Invoice</label>
           */}
                  <input
                    onChange={readRqFile}
                    ref={rqRef}
                    accept=".pdf"
                    multiple={false}
                    type="file"
                    id="rq4"
                    name="rq4"
                  />
                </div>
              </div>

               {/* for Autopay upload */}
              <div className="block">
                <div className="top-block">
                  <h4 className="">Autopay</h4>
                </div>

                <div className="bottom-block">
                  {/* <label htmlFor="autopay" className="custom-file-label">Choose Autopay Contract</label>
           */}
                  <input
                    onChange={readApFile}
                    ref={apRef}
                    accept=".pdf"
                    multiple={false}
                    type="file"
                    id="autopay"
                    name="autopay"
                  />

                </div>
              </div>

            </div>

            <div className="bottom">
              {/* AP can be uploaded seperatly  */}
            <CustomButton
                btnLabel="Upload"
                buttonType='success'
                onClick={onTypeChange}
                disabled={!(rqresult && result)}
                customIcon={<CloudUploadIcon />}
                // disabled={!(rqresult && result) && !apresult}
                // disabled={
                // !(apresult || (rqresult && result)) || // Enable if apresult is true or both rqresult and result are true
                // (apresult && (rqresult || result) && !(rqresult && result)) // Disable if apresult is true and only one of rqresult or result is true
                // }
              />

                  {/* <Button
                variant="contained"
                color="success"
                onClick={onTypeChange}
                disabled={!(rqresult && result)}
                endIcon={<CloudUploadIcon />}
                type="submit"
                >
                Upload            
                </Button> */}
              
            </div>
          </div>
          <AccessoryBlock
            username={username}
            dateConversion={dateConversion}
            manualSkuList={manualSkuList}
            eventinfoforCis={eventinfoforCis}
          />
          <ManualCisBlock manualSkuList={manualSkuList} eventinfoforCis={eventinfoforCis}/>
        </div>
      </div>
    </div>
  );
};

export default Home;
